// import { PhotoCamera } from "@mui/icons-material";
import {
    Box,
    Button,
    Card,
    Grid,
    Stack,
    Typography,
    useTheme,
} from '@mui/material';
import { H3 } from 'components/Typography';
import { useNavigate } from 'react-router-dom';
// import { Small, Tiny } from "components/Typography";
import { useFormik } from 'formik';
import DashboardLayout from 'layouts/Dashboard/DashboardLayout';
import GetSubmissionTypeService from 'services/submissionType/GetSubmissionTypeService';
import useAuth from 'hooks/useAuth';
// import * as Yup from "yup"; // styled components
import { useEffect } from 'react';
import AbstractSubmissionCreateService from 'services/abstract/AbstractSubmissionCreateService';
import axiosInstance from 'utils/axios';
import isValidDate from 'utils/isValidDate';
import SecondaryButton from 'components/buttons/SecondaryButton';
import PrimaryButton from 'components/buttons/PrimaryButton';
// import { useState } from "react";

// const ButtonWrapper = styled(Box)(({
//   theme
// }) => ({
//   width: 100,
//   height: 100,
//   display: "flex",
//   borderRadius: "50%",
//   alignItems: "center",
//   justifyContent: "center",
//   backgroundColor: theme.palette.action.disabledBackground
// }));
// const validationSchema = Yup.object().shape({});
// const UploadButton = styled(Box)(({
//   theme
// }) => ({
//   width: 50,
//   height: 50,
//   display: "flex",
//   borderRadius: "50%",
//   border: "2px solid",
//   alignItems: "center",
//   justifyContent: "center",
//   borderColor: theme.palette.background.paper,
//   backgroundColor: theme.palette.action.disabledBackground
// }));
// const SwitchWrapper = styled(Box)(() => ({
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   width: "100%",
//   marginTop: 10
// }));

const AbstractSubmissionCreate = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { user } = useAuth();
    const initialValues = {
        user: localStorage.getItem('userId'),
        type: '',
    };
    const { values, handleSubmit, setFieldValue } = useFormik({
        initialValues,
        onSubmit: async (values) => {
            await AbstractSubmissionCreateService(values)
                .then((response) => {
                    navigate(`/dashboard/abstract-edit/${response.data.id}`);
                })
                .catch((err) => console.log(err));
        },
    });
    const getData = async () => {
        await axiosInstance
            .get('api/system-parameters/name/end_off_submission_period')
            .then(({ data }) => {
                if (!isValidDate(data.value)) {
                    navigate('/dashboard/abstract-list');
                }
            })
            .catch((err) => console.log(err));
    };
    useEffect(() => {
        if (localStorage.getItem('role') !== 'admin') {
            getData();
        }
    }, []);
    const { listData } = GetSubmissionTypeService();
    const onChooseCategory = (id) => {
        setFieldValue('type', id);
    };
    return (
        <DashboardLayout>
            <Box pt={2} pb={4}>
                <Card
                    sx={{
                        padding: 3,
                    }}
                >
                    <H3 sx={{ mt: 0 }}>Abstract Submission Form</H3>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Box marginRight={1}>
                                    <Typography>Choose Category</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box>
                                    <Stack
                                        direction="row"
                                        spacing={0}
                                        flexWrap={'wrap'}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: 2,
                                            }}
                                        >
                                            {listData &&
                                                listData.map((el, i) => (
                                                    <Button
                                                        key={i}
                                                        sx={{
                                                            borderRadius:
                                                                theme.spacing(
                                                                    1.5,
                                                                ),
                                                        }}
                                                        size="medium"
                                                        onClick={() =>
                                                            onChooseCategory(
                                                                el.id,
                                                            )
                                                        }
                                                        variant={
                                                            values.type ===
                                                            el.id
                                                                ? 'contained'
                                                                : 'outlined'
                                                        }
                                                    >
                                                        {el.name}
                                                    </Button>
                                                ))}
                                        </Box>
                                    </Stack>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <PrimaryButton
                                    type="submit"
                                    variant="contained"
                                    sx={{ mr: 3 }}
                                    disabled={!values.type}
                                >
                                    Create
                                </PrimaryButton>
                                <SecondaryButton
                                    variant="outlined"
                                    onClick={() =>
                                        navigate('/dashboard/abstract-list')
                                    }
                                >
                                    Cancel
                                </SecondaryButton>
                            </Grid>
                        </Grid>
                    </form>
                </Card>
            </Box>
        </DashboardLayout>
    );
};

export default AbstractSubmissionCreate;
